import script from "./SigninSignup.vue?vue&type=script&setup=true&lang=ts"
export * from "./SigninSignup.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./SigninSignup.vue?vue&type=style&index=0&id=5482a4ab&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__